import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plus, MoveRight, ChevronRight, ChevronDown, X } from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";
import StatusChip from "../../../../../component/ui/chip/status";
import Swal from "sweetalert2";
import ProjectQuickView from "../popup";

export default function LeadCard({
  lead,
  onClick,
  colors,
  onSuccess = () => {},
  onError = () => {},
  productionUsers = [],
  getUsers = () => {},
  getData = () => {},
  onDropdownToggle = () => {},
  isActiveDrop = false,
  isOpen,
  onToggle,
  closeDrop = () => {},
}) {
  const [editAccount, setEditAccount] = useState(false);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  const editDeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditAccount(true);
  };

  const [showAll, setShowAll] = useState(false);

  const users = Array.isArray(lead?.assigned) ? lead.assigned : [];

  const visibleUsers = showAll ? users : users.slice(0, 2);
  const hiddenCount = users.length - 3;

  const truncateText = (str, max = 25) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "..." : str;
  };

  // Add Assigned
  const [search, setSearch] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  const apiCall = useApiCall();

  useEffect(() => {
    if (search.trim() === "") {
      setFilteredUsers(productionUsers);
    } else {
      setFilteredUsers(
        productionUsers.filter((u) =>
          u.name.toLowerCase().includes(search.toLowerCase()),
        ),
      );
    }
  }, [search, productionUsers]);

  const addAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this user in project?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      console.log("User cancelled");
      return;
    }

    console.log("user", user);

    let data = {
      project_id: lead?.id,
      user_id: user?.userid,
    };

    try {
      const url = `project/assign-user-to-project`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "Assigned User Successfully",
        timer: 1500,
      });

      onToggle();
      getUsers();
      getData()
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      onToggle();
    }
  };

  const onToggleCard = () => {
    onToggle();

    if (!isOpen) {
      closeDrop();
      setShowAll(false);
    }
  };

  return (
    <>
      <motion.div
        className="flex p-4 rounded-lg border border-[#E1E4EA] bg-[#fff] transition-all duration-300 "
        style={{
          boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.10)",
        }}
      >
        <div className=" w-full flex flex-col gap-4">
          {/* Header */}

          <div className="flex flex-col gap-2">
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <h4
                  className={`font-normal text-[rgba(14,18,27,0.60)] text-sm leading-tight truncate`}
                >
                  Project
                </h4>
              </div>
            </div>

            <div className="text-[18px] text-[#0E121B] font-semibold">
              {truncateText(lead?.name, 25)}
            </div>
          </div>

          {/* Middle Info */}
          <div className="flex flex-col">
            <div className="flex justify-between items-center py-[10px]">
              <span
                className={`font-medium text-[rgba(14,18,27,0.60)] text-sm leading-tight truncate`}
              >
                Status
              </span>
              <span
                className={`py-1 px-[10px] bg-[${
                  colors?.color ? colors?.color : "#335CFF"
                }] rounded-2xl text-white text-xs `}
                style={
                  colors?.color
                    ? { backgroundColor: colors?.color }
                    : { backgroundColor: "#335CFF" }
                }
              >
                {lead?.total_tasks} Tasks
              </span>
            </div>
            <div className="py-[10px] px-[14px]  border border-[#E1E4EA] bg-[#F3F3F3] rounded-[5px] flex justify-center items-center">
              <div className="flex flex-col justify-center items-center gap-4 w-full text-center">
                <span className="font-semibold text-[rgba(14,18,27,0.60)] text-[10px] leading-tight">
                  In Process
                </span>
                <span className="text-3xl text-[#0E121B] font-semibold">
                  {lead?.pending_tasks}
                </span>
              </div>
              <div
                className="h-full  w-1"
                style={
                  colors?.color
                    ? { backgroundColor: colors?.color }
                    : { backgroundColor: "#335CFF" }
                }
              ></div>
              <div className="flex flex-col justify-center items-center gap-4 w-full text-center">
                <span className="font-semibold text-[rgba(14,18,27,0.60)] text-[10px] leading-tight">
                  Completed
                </span>
                <span className="text-3xl text-[#0E121B] font-semibold">
                  {lead?.completed_tasks}
                </span>
              </div>
            </div>
          </div>

          {/* Bottom */}

          <div>
            <div className="flex justify-between items-center">
              <p
                className={`text-[rgba(14,18,27,0.60)] text-sm leading-tight font-medium `}
              >
                Project Details:
              </p>

              <ChevronDown
                className={`w-5 h-5 bg-white rounded-full transition-transform duration-200 cursor-pointer ${
                  isOpen ? "rotate-180" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleCard();
                }}
              />
            </div>

            {isOpen && (
              <div>
                <div className="flex gap-1 mt-1 text-sm leading-tight font-medium text-[#0E121B]">
                  <p> {lead?.customer}</p>
                </div>
                {/* completion */}
                <div className="flex flex-col py-[10px] gap-[10px]">
                  <div
                    className={`font-normal text-[rgba(14,18,27,0.60)] text-sm leading-tight `}
                  >
                    Completion
                  </div>
                  <div className="flex gap-1 items-center">
                    <p className=" font-normal">{lead?.percentage}%</p>

                    <div className="w-full h-[2px] bg-gray-200 rounded-full">
                      <div
                        className="h-[2px] bg-[#84CC16] rounded-full"
                        style={{ width: `${lead?.percentage}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
                {/* users */}
                <div className="flex mt-[17px] gap-1 items-center">
                  <p
                    className={`font-normal text-[rgba(14,18,27,0.60)] text-sm leading-tight `}
                  >
                    Users:
                  </p>

                  {/* show all assigned Users */}

                  <div className="relative">
                    <div
                      className="flex -space-x-2 cursor-pointer"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {lead?.assigned?.length > 0 &&
                        lead?.assigned?.slice(0, 3)?.map((each, idx) =>
                          each?.userimg ? (
                            <img
                              src={each?.userimg}
                              alt={each?.name}
                              className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                const fallback = document.createElement("div");
                                fallback.className =
                                  "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                fallback.innerText = (
                                  (each?.name?.split(" ")[0]?.[0] || "") +
                                  (each?.name?.split(" ")[1]?.[0] || "")
                                ).toUpperCase();
                                e.target.parentElement.appendChild(fallback);
                              }}
                            />
                          ) : (
                            <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                              {(each?.name?.split(" ")[0]?.[0] || "") +
                                (each?.name?.split(" ")[1]?.[0] || "")}
                            </div>
                          ),
                        )}

                      {hiddenCount > 0 && (
                        <div className="-ml-2 z-10 h-8 w-8 flex items-center justify-center rounded-full bg-[#84CC16] text-white text-xs font-medium border-2 border-white shadow-sm cursor-pointer">
                          +{hiddenCount}
                        </div>
                      )}
                    </div>

                    {showAll && (
                      <div className="absolute top-10  -left-14 right-0 w-64 max-h-60 bg-white rounded-xl shadow-xl p-3 z-30 overflow-hidden">
                        <div className="flex justify-between items-center mb-2 ">
                          <h4 className="text-sm font-medium">
                            Assigned Users
                          </h4>
                          <button
                            onClick={() => setShowAll(false)}
                            className="p-1 rounded hover:bg-gray-100 transition"
                          >
                            <X className="w-4 h-4 text-gray-500 hover:text-black" />
                          </button>
                        </div>

                        <div className="!overflow-y-auto w-full h-52 pb-3">
                          {lead?.assigned?.map((each, idx) => (
                            <div
                              key={idx}
                              className="flex items-center gap-2 mb-2 "
                            >
                              <div className="">
                                {each?.userimg ? (
                                  <img
                                    src={each?.userimg}
                                    alt={each?.name}
                                    className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
                                      const fallback =
                                        document.createElement("div");
                                      fallback.className =
                                        "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                      fallback.innerText = (
                                        (each?.name?.split(" ")[0]?.[0] || "") +
                                        (each?.name?.split(" ")[1]?.[0] || "")
                                      ).toUpperCase();
                                      e.target.parentElement.appendChild(
                                        fallback,
                                      );
                                    }}
                                  />
                                ) : (
                                  <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                    {(each?.name?.split(" ")[0]?.[0] || "") +
                                      (each?.name?.split(" ")[1]?.[0] || "")}
                                  </div>
                                )}
                              </div>
                              <span className="text-sm">{each.name}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* show add assigned user dropdown */}

                  <div>
                    <div className="projectDetail-cardLeftUserAddBtn selectUser">
                      <button
                        className="bg-[#000] text-white flex text-[12px] p-1 rounded-full items-center gap-1 selectUser-btn cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDropdownToggle();
                          setShowAll(false);
                        }}
                      >
                        {" "}
                        <Plus className="h-5 w-5" />
                      </button>

                      {/* Dropdown */}
                      {isActiveDrop && (
                        <div className="selectUser-view customSearch mt-2 border border-[#f6f6f6] shadow-xl p-3 rounded-xl  bg-white w-64 absolute  !right-4 z-20">
                          <div className="selectUser-search flex items-center gap-2  mb-2 border-gray-400 border-b pb-1">
                            <div className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <mask
                                  id="mask1"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect
                                    width="18"
                                    height="18"
                                    fill="#D9D9D9"
                                  ></rect>
                                </mask>
                                <g mask="url(#mask1)">
                                  <path
                                    d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                                    fill="#999999"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                            <input
                              type="text"
                              placeholder="Search User..."
                              className="customSearchInput border rounded px-2 py-1 w-full"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                          </div>

                          <div className="selectUser-list max-h-48 overflow-y-auto">
                            <ul className="customSearchList ProjectAssignUsersList">
                              {filteredUsers?.map((user) => (
                                <li
                                  key={user?.userid}
                                  className="UserForAssign flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-100 rounded"
                                  onClick={() => {
                                    addAssigned(user);
                                  }}
                                >
                                  <div className="avatar w-6 h-6 flex items-center justify-center bg-gray-300 rounded-full text-xs">
                                    {user?.name.substring(0, 1).toUpperCase()}
                                  </div>
                                  <em>{user?.name}</em>
                                </li>
                              ))}
                              {filteredUsers.length === 0 && (
                                <li className="p-1 text-gray-400">
                                  No users found
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Date */}

                <div className="flex items-center justify-between w-full py-2 rounded-lg bg-white">
                  <span className="text-[rgba(14,18,27,0.40)] text-xs font-semibold">
                    {lead.start_date}
                  </span>

                  <span className="text-[#0E121B] text-lg">
                    <MoveRight />
                  </span>
                  <span className="text-[rgba(14,18,27,0.40)] text-xs font-semibold">
                    {lead?.end_date ? lead?.end_date : lead.last_activity}
                  </span>
                </div>

                {/* see details */}

                <div className="flex justify-between items-center py-[10px]">
                  <div>
                    <StatusChip
                      color={
                        lead.status == "completed"
                          ? "green"
                          : lead.status == "pending"
                            ? "blue"
                            : "red"
                      }
                    >
                      {lead.status}
                    </StatusChip>
                  </div>

                  <button
                    className="group flex items-center  transition-all duration-200 gap-[2px]"
                    onClick={() => {
                      setEmpPopup(true);
                      setEmpData(lead);
                    }}
                  >
                    <span className="underline  text-sm bg-transparent  font-semibold">
                      See Details
                    </span>

                    {/* Greater than icon */}
                    <span className=" group-hover:translate-x-1 transition-transform duration-200  font-semibold">
                      <ChevronRight />
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </motion.div>

      {editAccount && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setEditAccount(false);
          }}
          data={lead?.completeLead}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {empPopup && (
        <ProjectQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
        />
      )}
    </>
  );
}
